import { useEffect, useState } from "react";
import {
  CircularAvatar,
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  Loader,
  TableHeader,
  TableLoader,
} from "../../../../components/commons";
import Select from "react-select";
import { USER_REPORT_COUNT_HEADERS } from "../../../../constant/tableHeadersConstants/userLoginSessionReportsHeaderConst";
import { connect } from "react-redux";
import {
  getUserReportAction,
  resetListingError,
  resetListingSuccess,
  resetUserReportList,
} from "../../../../redux/listing";
import moment from "moment";
import ReactDatePicker from "react-datepicker";
import { Label } from "reactstrap";
import { RootState } from "../../../../redux/rootReducers";
import { getAllFinacUsersAction, resetSession } from "../../../../redux/auth";
import { GetUserReportCountPayloadType } from "../../../../commonTypes/listing";
import { components } from "react-select";
import useDebounce from "../../../../customHooks/useDebounce";
import { GetAllFinacUserPayloadType } from "../../../../commonTypes/authTypes";
import { CalenderIcon } from "../../../../components/Icon";
import { formatDate, handleDate } from "../../../../utils/commonFunctions";
import UserReportCountTable from "../../../../components/AdminReports/UserLoginSessionReport/UserReportCountTable";
import { UserReportCountType } from "../../../../redux/listing/listingTypes";

export type DropDownUserType = {
  value: number|null;
  label: string;
};
type AppProps = {
  token: string | null;
  userFetching: boolean;
  finacUser: any;
  fetching: boolean;
  error: string | null;
  success: number | null;
  statusCode: number | null;
  userReportList: [] | UserReportCountType[];
  dispatchResetListingError: () => void;
  dispatchResetListingSuccess: () => void;
  dispatchUserReportAction: (data: GetUserReportCountPayloadType) => void;
  dispatchResetUserReportList: () => void;
  dispatchResetSession: () => void;
  dispatchGetAllFinacUsersAction?: (data: GetAllFinacUserPayloadType) => void;
};
const UserReport = ({
  token,
  fetching,
  error,
  success,
  statusCode,
  userFetching,
  finacUser,
  userReportList,
  dispatchResetListingError,
  dispatchResetListingSuccess,
  dispatchUserReportAction,
  dispatchResetUserReportList,
  dispatchResetSession,
  dispatchGetAllFinacUsersAction,
}: AppProps) => {
  const [user, setUser] = useState<DropDownUserType>({
    value: null,
    label: "Select..",
  });
  const [displayedUser, setDispalyedUser] = useState<DropDownUserType>({
    value: null,
    label: "Select..",
  });
  const [loadCondition, setLoadCondition] = useState(true);
  const [offset, setOffset] = useState<number>(0);
  const [text, setText] = useState<string>("");
  const [limit, setLimit] = useState<number>(20);
  const [userList, setUserList] = useState<any>([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [displayStartDate, setDisplayStartDate] = useState("");
  const [displayEndDate, setDisplayEndDate] = useState("");

  useEffect(() => {
    dispatchResetListingError();
    dispatchResetListingSuccess();
    dispatchResetUserReportList();
  }, []);

  useEffect(() => {
    if (displayEndDate !== endDate || startDate !== displayStartDate) {
      setDisplayStartDate(formatDate(startDate));
      setDisplayEndDate(formatDate(endDate));
    }
  }, [userReportList]);
  useEffect(() => {
    const finalUserData = finacUser?.data?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name ? user?.first_name : ""} ${
          user?.last_name ? user?.last_name : ""
        }`,
        image: user?.profile_pic?.file_url,
      };
    });
    if (offset > 0) {
      setUserList([...userList, ...finalUserData]);
    } else {
      setUserList(finalUserData);
    }
  }, [finacUser]);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset,
        limit,
        user_type: "stco_users",
        status: 1,
        search_term: text,
      };
      if (offset <= finacUser?.total_count) {
        dispatchGetAllFinacUsersAction?.(finalUserData);
      }
    }
  }, [offset]);

  const fetchNewData = (search: string) => {
    const finalData = {
      token,
      offset,
      limit,
      user_type: "stco_users",
      status: 1,
      search_term: text,
    };
    dispatchGetAllFinacUsersAction?.(finalData);
  };

  const handleStartDateChange = (date: string) => {
    const value = handleDate(date);
    setStartDate(value);
  };
  const handleEndDateChange = (date: string) => {
    const value = handleDate(date);
    setEndDate(value);
  };
  useDebounce(
    () => {
      if (text) {
        fetchNewData(text);
      } else {
        const finalData = {
          token,
          offset,
          limit,
          user_type: "stco_users",
          status: 1,
          search_term: text,
        };
        dispatchGetAllFinacUsersAction?.(finalData);
      }
    },
    500,
    [text]
  );

  const checkBottom = (e: any) => {
    setLoadCondition(false);

    setOffset((prv: any) => prv + limit);
  };
  const handleUserDropdownChange = (data: any) => {
    setUser({
      value: data?.value,
      label: data?.label,
    });
  };

  const onMenuClose = () => {
    setLoadCondition(true);
  };
  const handleSubmitData = () => {
    setDispalyedUser(user)
    let finalData: GetUserReportCountPayloadType = {
      token,
      start_date: formatDate(startDate),
      end_date: formatDate(endDate),
      user_id: user?.value,
    };

    dispatchUserReportAction(finalData);
  };
  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };
  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetListingError();
            }}
          />
        );
      }
    }

    return false;
  };
  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <CommonHeader title="User Report" />
        </div>
      </div>
      <div className="col-md-12 mt-4">
        <div className="new-table-card">
            <div style={{ display: "flex", alignItems: "start" }} className="pt-5 pl-2">
              <div className="col-md-3 form-group d-flex flex-column">
                <label className="mb-1" htmlFor="">
                  User
                </label>
                <Select
                  onMenuClose={onMenuClose}
                  components={{ Option }}
                  isSearchable={true}
                  options={userList}
                  isLoading={userFetching}
                  value={user}
                  onMenuScrollToBottom={(e: any) => checkBottom(e)}
                  onChange={(e) => handleUserDropdownChange(e)}
                  onInputChange={(e) => {
                    setLoadCondition(false);
                    setText(e);
                    setOffset(0);
                  }}
                />
              </div>
              <div className="col-md-3" style={{ marginTop: "27px" }}>
                <div className="form-group">
                  <div className="date-picker-wraper mr-0">
                    <Label className="m-0 p-0 w-100">
                      <ReactDatePicker
                        dateFormat="dd-MM-yyyy"
                        selected={
                          startDate
                            ? new Date(
                                moment(
                                  `${startDate}T00:00:00`,
                                  "YYYY-MM-DD"
                                ).format("YYYY-MM-DD[T]HH:mm:ss")
                              )
                            : null
                        }
                        onChange={(e: any) => {
                          handleStartDateChange?.(
                            moment(e).format("YYYY-MM-DD")
                          );
                        }}
                        fixedHeight
                        showMonthDropdown
                        showYearDropdown
                        name="dateOfInvoice"
                        placeholderText="Start Date"
                        className="form-control"
                      />
                      <span
                        className="calender-icon"
                        style={{ right: "30px", cursor: "pointer" }}
                      >
                        <CalenderIcon />
                      </span>
                    </Label>
                  </div>
                </div>
              </div>
              <div className="col-md-3" style={{ marginTop: "27px" }}>
                <div className="form-group">
                  <div className="date-picker-wraper mr-0">
                    <Label className="m-0 p-0 w-100">
                      <ReactDatePicker
                        dateFormat="dd-MM-yyyy"
                        selected={
                          endDate
                            ? new Date(
                                moment(
                                  `${endDate}T00:00:00`,
                                  "YYYY-MM-DD"
                                ).format("YYYY-MM-DD[T]HH:mm:ss")
                              )
                            : null
                        }
                        onChange={(e: any) => {
                          handleEndDateChange?.(moment(e).format("YYYY-MM-DD"));
                        }}
                        fixedHeight
                        showMonthDropdown
                        showYearDropdown
                        name="dateOfInvoice"
                        placeholderText="End Date"
                        className="form-control"
                      />
                      <span
                        className="calender-icon"
                        style={{ right: "30px", cursor: "pointer" }}
                      >
                        <CalenderIcon />
                      </span>
                    </Label>
                  </div>
                </div>
              </div>

              <div className="col-md-3" style={{ marginTop: "28px" }}>
                <button
                  className="btn btn-primary"
                  onClick={handleSubmitData}
                  disabled=
                  {!user?.value || !startDate?.length || !endDate?.length}
                >
                  Get Data
                </button>
              </div>
            </div>
            <hr className="mt-4 mb-4" />
            {userReportList && userReportList?.length === 0 && !fetching ? (
              <EmptyListPage title="No Data Found!" imageWidth="30%" />
            ) : (
              <>
                <h5 className="text-center">{displayedUser?.label}</h5>
                <div className="d-flex justify-content-center mt-3">
                  <h6 className="text-center mr-4">
                    Start Date:{" "}
                    <span className="font-weight-bolder">
                      {displayStartDate}
                    </span>
                  </h6>
                  <h6 className="text-center">
                    End Date:{" "}
                    <span className="font-weight-bolder">{displayEndDate}</span>
                  </h6>
                </div>
                {fetching ? (
                  <TableLoader Rows={10} ColumnPerRow={4} />
                ) : (
                  <div className="jobsType">
                    <table className="table thead-light table-bordered">
                      <thead className="text-left sticky-table-header-without-zindex">
                        <TableHeader tableHeader={USER_REPORT_COUNT_HEADERS} />
                      </thead>
                      <tbody>
                        <UserReportCountTable
                          data={userReportList}
                          tableHeaders={USER_REPORT_COUNT_HEADERS}
                        />
                      </tbody>
                    </table>
                  </div>
                )}
              </>
            )}
        </div>
      </div>
      {fetching && <Loader />}
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  success: state.listing.success,
  fetching: state.listing.fetching,
  token: state.auth.token,
  error: state.listing.error,
  statusCode: state.listing.statusCode,
  finacUser: state.auth.finacUsersList,
  userFetching: state.auth.fetching,
  userReportList: state.listing.userReportList,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetListingSuccess: () => dispatch(resetListingSuccess()),
  dispatchResetListingError: () => dispatch(resetListingError()),
  dispatchUserReportAction: (data: GetUserReportCountPayloadType) =>
    dispatch(getUserReportAction(data)),
  dispatchResetUserReportList: () => dispatch(resetUserReportList()),
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserReport);
